module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/55O44n6YDONZLZ1Ux4H76x-6b8ca4d85eba99e6d2f25c93ac9c8193.jpg";